
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import SelectCompany from '../components/SelectCompany';

const SelectCompanyPage = ({ token, setCompany }) => {
  const [companies, setCompanies] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) return; 
    const fetchCompanies = async () => {
      console.log("Token recibido en SelectCompanyPage:", token);
      try {
        const response = await axios.get(`${API_BASE_URL}/api/company/companies`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCompanies(response.data);
      } catch (error) {
        console.error('Error al obtener las empresas:', error);
      }
    };
    fetchCompanies();
  }, [token]);
  const handleSelectCompany = (company) => {
    setCompany(company);
    navigate('/dashboard');
  };
  const handleCreateCompany = () => {
    navigate('/create-company');
  };
  return (
    <div>
      {companies.length > 0 ? (
        <SelectCompany companies={companies} onSelectCompany={handleSelectCompany} />
      ) : (
        <p>No tienes ninguna empresa asociada. Por favor, contacta al administrador o crea tu empresa en el boton de abajo .</p>
      )}
      <button onClick={handleCreateCompany}>Crear Empresa</button>
    </div>
  );
};

export default SelectCompanyPage;
